import { useEffect, useState } from 'react';
import { useQuery, useReactiveVar } from '@apollo/client';
import { GET_MAPS_CONFIGURATION } from '../graphql/maps/get-maps-configuration';
import { yandexMapStyleUpdatedAtVar } from '../graphql/configuration/configuration.cache';
import { YANDEX_MAP_CUSTOM_STYLE } from '../constants/map-styles';

const STORAGE_KEY_STYLES = 'yandex-map-styles';
const STORAGE_KEY_TIMESTAMP = 'yandex-map-styles-timestamp';

export const useMapStyles = () => {
  const [mapStyles, setMapStyles] = useState<any[] | null>(null);
  const configTimestamp = useReactiveVar(yandexMapStyleUpdatedAtVar);
  const cachedTimestamp = localStorage.getItem(STORAGE_KEY_TIMESTAMP);
  const shouldFetch = configTimestamp && cachedTimestamp !== configTimestamp;
  const cachedStyles = localStorage.getItem(STORAGE_KEY_STYLES);

  const { data, loading, error } = useQuery(GET_MAPS_CONFIGURATION, {
    variables: { platform: 'WEB' },
    context: { clientName: 'consumer' },
    skip: !shouldFetch,
  });

  useEffect(() => {
    let isMounted = true;

    if (cachedStyles && !shouldFetch) {
      try {
        const parsed = JSON.parse(cachedStyles);
        if (isMounted) {
          setMapStyles(parsed);
        }
      } catch (err) {
        if (isMounted) {
          setMapStyles([...YANDEX_MAP_CUSTOM_STYLE]);
        }
      }
    }

    return () => {
      isMounted = false;
    };
  }, [shouldFetch, cachedStyles]);

  useEffect(() => {
    let isMounted = true;

    if (data?.mapsConfiguration && !cachedStyles && shouldFetch) {
      try {
        const styles = JSON.parse(data.mapsConfiguration);
        if (isMounted) {
          setMapStyles(styles);
        }
        localStorage.setItem(STORAGE_KEY_STYLES, data.mapsConfiguration);
        if (configTimestamp) {
          localStorage.setItem(STORAGE_KEY_TIMESTAMP, configTimestamp);
        }
      } catch (err) {
        if (isMounted) {
          setMapStyles([...YANDEX_MAP_CUSTOM_STYLE]);
        }
      }
    } else if (error && !mapStyles) {
      if (isMounted) {
        setMapStyles([...YANDEX_MAP_CUSTOM_STYLE]);
      }
    }

    return () => {
      isMounted = false;
    };
  }, [data, error, configTimestamp, cachedStyles, shouldFetch, mapStyles]);

  return {
    mapStyles: mapStyles || [...YANDEX_MAP_CUSTOM_STYLE],
    loading,
  };
};
